import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import ModulesPage from "@/pages/Modules";
import Pricing from "@/pages/Pricing";
import AuditPage from "@/pages/Audit";

const SITE_NAME = "PranaOs";
const DEFAULT_TITLE = `${SITE_NAME} | The hospital OS that breathes with you`;

const PAGE_TITLES = {
  "/": DEFAULT_TITLE,
  "/modules": `Modules | ${SITE_NAME}`,
  "/pricing": `Pricing | ${SITE_NAME}`,
  "/audit": `Hospital Audit | ${SITE_NAME}`,
};

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function DocumentTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = PAGE_TITLES[pathname] ?? DEFAULT_TITLE;
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App font-sans-body">
      <BrowserRouter>
        <ScrollToTop />
        <DocumentTitle />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/modules" element={<ModulesPage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="*" element={<Landing />} />
        </Routes>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
